import { ThemeConfig } from "antd"

export const defaultThemeColors = {
  "--color-bg-layout": "#f7f9fb",
  "--color-default-ghost": "#1c6c2a",
  "--color-ghost-bg": "#1C6C2A1A",
  "--color-primary": "#1c6c2a",
  "--color-primary-active": "#337b40",
  "--color-primary-bg": "rgb(28 108 42 / 10%)",
  "--color-primary-hover": "#27582f",
  "--color-table-header-bg": "#e9f1ea",
  "--color-table-row-expanded-bg": "#fff",

  "--font-family": "Inter, sans-serif",

  "--primary-gradient": `
    radial-gradient(
      117.93% 122.91% at 105.19% 107.49%,
      #083c11 0%,
      #1c6c2a 100%
    )
  `,
}

export const DEFAULT_ANT_THEME: ThemeConfig = {
  components: {
    Button: {
      defaultGhostColor: defaultThemeColors["--color-primary"],
      ghostBg: defaultThemeColors["--color-ghost-bg"],
    },
    Table: {
      borderRadius: 2,
      cellFontSize: 12,
      fontSize: 12,
      headerBg: defaultThemeColors["--color-table-header-bg"],
      padding: 12,
      rowExpandedBg: "#FFF",
    },
    Tabs: {
      titleFontSize: 12,
    },
  },
  token: {
    colorBgLayout: defaultThemeColors["--color-bg-layout"],
    colorInfo: defaultThemeColors["--color-primary"],
    colorPrimary: defaultThemeColors["--color-primary"],
    colorPrimaryActive: defaultThemeColors["--color-primary-active"],
    colorPrimaryBg: defaultThemeColors["--color-primary-bg"],
    colorPrimaryHover: defaultThemeColors["--color-primary-hover"],
    fontFamily: defaultThemeColors["--font-family"],
  },
}
